export default __webpack_public_path__ + "28822ee6455d2946f063e056c7b9dec5.svg";